import { useEffect, useState } from 'react'
import _ from 'lodash'

const handleMessageRaw = function (setKeys: (value: string) => void) {
  return function handleMessage (msg: MessageEvent<string>) {
    setKeys(msg.data)
  }
}

export const useScanner = () => {
  const [keys, setKeys] = useState<string>('')

  useEffect(() => {
    const throttledHandleMessage = _.throttle(handleMessageRaw(setKeys), 1000)
    window.addEventListener('message', throttledHandleMessage)

    return function () {
      window.removeEventListener('message', throttledHandleMessage)
    }
  }, [setKeys])

  return {
    keys,
    getScan: () => {
      setKeys(() => '')
      return keys
    },
    clearKeys: () => { setKeys('') }
  }
}
